module.exports = __webpack_public_path__ + "images/ba1836268277d3a8b5d770049150b1e5.jpg";